// Remove a trailing slash from a string
function trimTrailingSlash (str = '') {
  const l = str.length
  if (l > 1 && str.charAt(l - 1) === '/') {
    return str.slice(0, l - 1)
  }
  return str
}

// Return the last element of an array
function last (arr = []) {
  return arr[arr.length - 1]
}

// Return the last path of a string. Example /a/b/c returns c
function lastPath (str = '') {
  const paths = str.split('/')
  return last(paths)
}

// Applys styles to active mobile navigation menu
function mobileNav (currPath, nodes) {
  nodes.forEach(c => {
    if (c && c.getAttribute('href')) {
      const href = c.getAttribute('href').replace('/', '')
      // This link is the current page, highlight it with a classname
      if (href === currPath) {
        return c.classList.add('active-nav-item')
      }
    }
  })
}

export default function phoneInputMasking (document, moduleHTML, appEventEmitter) {
  // Get the last path in the url
  const currPath = lastPath(trimTrailingSlash(document.URL))
  const navItems = moduleHTML.childNodes[0].childNodes

  // Loop through each child a tag, if it matches give it a new class
  navItems.forEach(n => {
    const childNodes = n.childNodes
    childNodes.forEach(cc => {
      // Only get nodes with href attr
      if (cc && cc.getAttribute('href')) {
        const href = cc.getAttribute('href').replace('/', '')
        // This link is the current page, highlight it with a classname
        if (href === currPath) {
          console.log('match')
          return cc.classList.add('active-nav-item')
        }
      }

      // Mobile Nav has a different HTML structure to navigate
      if (cc.nodeName === 'DIV') {
        return mobileNav(currPath, cc.childNodes)
      }
    })
  })
}
